import { render, staticRenderFns } from "./KOLPayoutBatches.vue?vue&type=template&id=56607579&"
import script from "./KOLPayoutBatches.vue?vue&type=script&lang=js&"
export * from "./KOLPayoutBatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports